import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/zilliqa/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: true,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  SAFE_UTILS_SUPPORTED: false,
  EXTRA_FOOTER_LINKS: [],
  IS_LICENSED: false,
  LOGO_DIMENSIONS: {
    HEADER: {
      H: '40px',
    },
    WELCOME: {
      W: '120px',
      H: '40px',
    },
  },
} as TemplateConfig
export default TEMPLATE_CONFIG
